export default "__VITE_ASSET__BVg0EBy___"